import { generateClient } from "aws-amplify/api";
import { get_ticket } from '@/graphql/queries'
import { mapTicket } from './ticketHelpers'

export default {
  data() {
    return {
      ticketDetail: null,
    }
  },
  methods: {
    async fetchTicket(ticketId) {
      try {
        const client = generateClient();
        const response = await client.graphql({
          query: get_ticket,
          variables: {
            input: {
              ticket_id: ticketId
            }
          }
        })

        let responseData = response.data.get_ticket
        if (typeof responseData === "string") {
          responseData = JSON.parse(responseData)
        }

        if (responseData.status == "SUCCESS") {
          this.ticketDetail = mapTicket(responseData.data || {})
        } else {
          this.ticketDetail = null
        }
      } catch (error) {
        console.error("Error fetching ticket:", error);
        this.ticketDetail = null;
        throw error;
      }
    },
  },
};
